import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Apollo} from "apollo-angular";
import {
  K2SoftwareSolutionGqlModel,
  K2SoftwareSolutionInputGqlModel,
  K2SoftwareSolutionInputResponseGqlModel,
} from "./software-solutions.gql-model";

@Injectable()
export class SoftwareSolutionsService {
  constructor(
    private http: HttpClient,
    private apollo: Apollo,
  ) {}

  async getSoftwareSolutionsListForCustomer(customerId: string = ""): Promise<K2SoftwareSolutionGqlModel[]> {
    const query = K2SoftwareSolutionGqlModel.query;
    const variables = K2SoftwareSolutionGqlModel.variables(customerId);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(K2SoftwareSolutionGqlModel.mapper)
      .toPromise();
  }

  async updateSoftwareSolutionsList(
    k2softwareSolutions: K2SoftwareSolutionGqlModel[],
    projectId,
  ): Promise<K2SoftwareSolutionInputResponseGqlModel> {
    const model = new K2SoftwareSolutionInputGqlModel({k2softwareSolutions});
    model.variables.projectId = projectId;

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(K2SoftwareSolutionInputGqlModel.mapper)
      .toPromise();
  }
}
